<app-esqueleto-tableros>
  <!--NOMBRE MÓDULO / TABLERO-->
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <!--FILTROS-->
  <app-filters filtros
    [name]="'cues.analisis-clima.evaluacion' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="yearChange($event)"
    [click]="false"
  />
  <app-filters filtros
    [name]="'cues.analisis-clima.variable-1' | translate"
    [array]="variables1"
    [typeFilter]="Filters.ESCENARIOS"
    [panelAncho]="true"
    (eventClick)="seleccionarVariable1($event)"
    [click]="false"
  />
  <app-filters filtros
    [name]="'cues.analisis-clima.variable-2' | translate"
    [array]="variables2"
    [typeFilter]="Filters.ESCENARIOS"
    [panelAncho]="true"
    (eventClick)="seleccionarVariable2($event)"
    [click]="false"
  />
  <app-filters filtros
    [name]="'cues.analisis-clima.dimension' | translate"
    [array]="dimensiones"
    [typeFilter]="Filters.ESCENARIOS"
    (eventClick)="seleccionarDimension($event)"
    [click]="false"
  />

  <!--BORRAR FILTROS-->
  <div borrador>
    <div class="w3-button w3-dropdown-click borrarFiltros"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="borrarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>

  <!--CONTENIDO DEL TABLERO-->
  <div contenido class="tableroInforme">
    @if (loadingResultados) {
      <div class="spinner-overlay">
        <div class="spinner-css"></div>
      </div>
    }
    <!--Lado izquierdo: tabla + gráfica-->
    <div class="leftSide">

      <!--ZONA TABLA-->
      <div class="zonaSup w3-white">
        <div class="w3-row headers w3-titulo-contenidomenuSC">
          <div class="w3-threequarter textoOverFlow">
            <ng-container [ngTemplateOutlet]="tituloZonaTpl"></ng-container>
          </div>
          <div class="w3-rest w3-right zonaIconos">
            <mat-icon class="iconoMen"
              (click)="abrirTabla()">
              zoom_out_map
            </mat-icon>
            <mat-icon class="iconoMen"
              [matMenuTriggerFor]="menuTabla">
              more_vert
            </mat-icon>
            <mat-menu #menuTabla="matMenu">
              <!--Semáforo (con submenú de colores)-->
              <button mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuSemaforo">
                <mat-icon class="iconoGris">traffic</mat-icon>
                <span>{{ 'cues.analisis-clima.semaforo' | translate }}</span>
              </button>
              <!--Métrica (con submenú)-->
              <button mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuMetrica">
                <mat-icon class="iconoGris">tag</mat-icon>
                <span>{{ 'cues.analisis-clima.metrica' | translate }}</span>
              </button>
              <mat-divider></mat-divider>
              <!--Exportar-->
              <button mat-menu-item class="w3-caja-menu" (click)="exportar()">
                <mat-icon class="iconoGris">description</mat-icon>
                <span>{{ 'cues.analisis-clima.exportar' | translate }}</span>
              </button>
            </mat-menu>
            <!--Submenú semáforo-->
            <mat-menu #menuSemaforo="matMenu">
              <button mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled': semaforoFiltro === 'todos'}"
                (click)="cambioSemaforo('todos')">
                <span>{{ 'cues.analisis-clima.todos' | translate }}</span>
              </button>
              @for (s of semaforos; track $index) {
                <button mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled': semaforoFiltro === s.color}"
                  (click)="cambioSemaforo(s.color)">
                  <mat-icon class="puntoSemaforo" [ngStyle]="{'color': s.color}">fiber_manual_record</mat-icon>
                  <span>{{ redondeoSemaforo(s.min) }} – {{ redondeoSemaforo(s.max) }}</span>
                </button>
              }
            </mat-menu>
            <!--Submenú métrica-->
            <mat-menu #menuMetrica="matMenu">
              <button mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled': metrica === 'calificacion'}"
                [disabled]="metrica === 'calificacion'" (click)="cambioMetrica('calificacion')">
                <span>{{ 'cues.analisis-clima.calificacion' | translate }}</span>
              </button>
              <button mat-menu-item class="w3-caja-menu" [ngClass]="{'w3-disabled': metrica === 'porcentaje'}"
                [disabled]="metrica === 'porcentaje'" (click)="cambioMetrica('porcentaje')">
                <span>{{ 'cues.analisis-clima.porcentaje' | translate }}</span>
              </button>
            </mat-menu>
          </div>
        </div>

        <div class="zonaTabla w3-scroll">
          @if (loadingResultados) {
            <app-skeleton-table [columnas]="6" [filas]="5" />
          } @else {
            <ng-container [ngTemplateOutlet]="tablaTpl"></ng-container>
          }
        </div>
      </div>

      <!--ZONA GRÁFICA-->
      <div class="zonaInf w3-white">
        <div class="w3-row headers w3-titulo-contenidomenuSC">
          <div class="w3-threequarter textoOverFlow">
            <ng-container [ngTemplateOutlet]="tituloZonaTpl"></ng-container>
          </div>
          <div class="w3-rest w3-right zonaIconos">
            <mat-icon class="iconoMen" (click)="etiquetasZona1 = !etiquetasZona1"
              [matTooltip]="'cues.resultados-clima.tooltip-etiquetas' | translate">{{ etiquetasZona1 ? 'label_off' : 'label' }}</mat-icon>
            <mat-icon class="iconoMen"
              (click)="abrirGrafica()">
              zoom_out_map
            </mat-icon>
            <mat-icon class="iconoMen"
              [matMenuTriggerFor]="menuGrafica">
              more_vert
            </mat-icon>
            <mat-menu #menuGrafica="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="tiposGrafica">
                <mat-icon class="iconoGris">assessment</mat-icon>
                <span>{{'cues.resultados-clima.menu-graficas' | translate}}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item class="w3-caja-menu" (click)="exportarGrafica()">
                <mat-icon class="iconoGris">image</mat-icon>
                <span>{{ 'cues.analisis-clima.exportar' | translate }}</span>
              </button>
            </mat-menu>
            <mat-menu #tiposGrafica="matMenu">
              <button mat-menu-item (click)="cambiarTipoGrafica(types.BAR)" [disabled]="type === types.BAR">
                <mat-icon class="iconoGris">bar_chart</mat-icon><span>{{'cues.resultados-clima.grafica-barras' | translate}}</span>
              </button>
              <button mat-menu-item (click)="cambiarTipoGrafica(types.LINE)" [disabled]="type === types.LINE">
                <mat-icon class="iconoGris">show_chart</mat-icon><span>{{'cues.resultados-clima.grafica-linea' | translate}}</span>
              </button>
              <button mat-menu-item (click)="cambiarTipoGrafica(types.AREA)" [disabled]="type === types.AREA">
                <mat-icon class="iconoGris">area_chart</mat-icon><span>{{'cues.resultados-clima.grafica-area' | translate}}</span>
              </button>
              <button mat-menu-item (click)="cambiarTipoGrafica(types.BUBBLE)" [disabled]="type === types.BUBBLE">
                <mat-icon class="iconoGris">bubble_chart</mat-icon><span>{{'cues.resultados-clima.grafica-burbujas' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="zonaGraf">
          @if (loadingResultados) {
            <app-skeleton-grafica [barras]="columnas.length || 5" [leyendas]="filas.length || 3" />
          } @else {
            <app-graficador
              #graficador
              [data]="chartData"
              [labels]="chartLabels"
              [type]="type"
              [colors]="colorMulti"
              [axisX]="var2Sel"
              [axisY]="[ ('cues.analisis-clima.calificacion' | translate) ]"
              [legend]="legendGraf"
              [zona]="1"
              [etiquetas]="etiquetasZona1"
              [formatEtiquetas]="true"
            />
          }
        </div>
      </div>
    </div>

    <!--Lado derecho: cards mejor/peor (un contenedor blanco por variable)-->
    <div class="rightSide">
      <div class="cardsZona w3-white">
        <div class="cardsTitulo textoOverFlow"
          matTooltip="{{ var1Sel }} {{ 'cues.analisis-clima.cards-tooltip' | translate }}">
          {{ var1Sel }} {{ 'cues.analisis-clima.cards-tooltip' | translate }}
        </div>
        @if (loadingResultados) {
          <app-skeleton-card />
          <app-skeleton-card />
        } @else {
          @for (c of cardsGrafica; track $index) {
            <app-tarjetas
              [header]="c.name || '—'"
              [valueStr]="formatoValor(c.score)"
              [footer]="''"
              [icon]="c.tipo === 'up' ? 'thumb_up' : 'thumb_down'"
              [iconColor]="'#1976d2'"
              [siceHeader]="'1rem'"
              [siceValue]="'1.8rem'"
              [sice]="'5vh'"
            />
          }
        }
      </div>
      <div class="cardsZona w3-white">
        <div class="cardsTitulo textoOverFlow"
          matTooltip="{{ var2Sel }} {{ 'cues.analisis-clima.cards-tooltip' | translate }}">
          {{ var2Sel }} {{ 'cues.analisis-clima.cards-tooltip' | translate }}
        </div>
        @if (loadingResultados) {
          <app-skeleton-card />
          <app-skeleton-card />
        } @else {
          @for (c of cardsTabla; track $index) {
            <app-tarjetas
              [header]="c.name || '—'"
              [valueStr]="formatoValor(c.score)"
              [footer]="''"
              [icon]="c.tipo === 'up' ? 'thumb_up' : 'thumb_down'"
              [iconColor]="'#1976d2'"
              [siceHeader]="'1rem'"
              [siceValue]="'1.8rem'"
              [sice]="'5vh'"
            />
          }
        }
      </div>
    </div>
  </div>
</app-esqueleto-tableros>

<!--====================== TEMPLATES REUTILIZABLES ======================-->

<!--Título de zona (se reutiliza en tabla, gráfica y modales)-->
<ng-template #tituloZonaTpl>
  <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">{{ 'cues.analisis-clima.titulo-zona' | translate }}
    | {{ var1Sel }} {{ 'cues.analisis-clima.vs' | translate }} {{ var2Sel }} | {{ dimSel }}</span>
  <span class="w3-margin-left-contenido w3-titulo-contenidomenuSC">&bull;</span>
  <span class="w3-margin-left-filter w3-subtitulo">{{ evalSel }}</span>
</ng-template>

<!--Tabla (se reutiliza en la zona y en el modal ampliar)-->
<ng-template #tablaTpl>
  <table class="w3-table allbordes tablaCombinada">
    <thead>
      <tr class="w3-table-title w3-center" style="line-height: 1.2;">
        <th class="w3-border-right-balance w3-center textoOverFlow" matTooltip="{{ var1Sel }}">{{ var1Sel }}</th>
        @for (col of columnas; track $index) {
          <th class="w3-border-right-balance w3-center textoOverFlow" matTooltip="{{ col }}">{{ col }}</th>
        }
        <th class="w3-border-right-balance w3-center textoOverFlow"
          matTooltip="{{ 'cues.analisis-clima.global' | translate }}">
          {{ 'cues.analisis-clima.global' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <!--Filas de datos-->
      @for (fila of matriz; track i; let i = $index) {
        <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2;">
          <td class="borderAllLow textoOverFlow" matTooltip="{{ filas[i] }}">{{ filas[i] }}</td>
          @for (val of fila; track $index) {
            <td class="borderAllLow celdaVal" [ngClass]="{'sinDato': val === null}">
              <div class="celdaSemaforo" [ngStyle]="estiloSemaforo(val)">
                <span>{{ formatoValor(val) }}</span>
              </div>
            </td>
          }
          <td class="borderAllLow alinCenter w3-table-titleLow" [ngClass]="{'sinDato': global[i] === null}">
            {{ formatoValor(global[i]) }}
          </td>
        </tr>
      }
      <!--Fila PROMEDIO-->
      <tr class="w3-table-trtd borderInfLow filaTotales" style="line-height: 1.2;">
        <td class="borderAllLow w3-table-titleLow">{{ 'cues.analisis-clima.promedio' | translate }}</td>
        @for (val of promedio; track $index) {
          <td class="borderAllLow alinCenter w3-table-titleLow" [ngClass]="{'sinDato': val === null}">
            {{ formatoValor(val) }}
          </td>
        }
        <td class="borderAllLow alinCenter w3-table-titleLow" [ngClass]="{'sinDato': promedioGlobal === null}">
          {{ formatoValor(promedioGlobal) }}
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>

<!--====================== MODALES AMPLIAR ======================-->

<!--Ampliar tabla-->
<app-modal [isOpen]="ampliarTabla" [export]="true" [iconoExport]="'description'" (exportFile)="exportar()" (close)="cerrarModales()">
  <div modal-header>
    <ng-container [ngTemplateOutlet]="tituloZonaTpl"></ng-container>
  </div>
  <div modal-body>
    <div class="contenidoModalTabla w3-scroll">
      <ng-container [ngTemplateOutlet]="tablaTpl"></ng-container>
    </div>
  </div>
</app-modal>

<!--Ampliar gráfica-->
<app-modal [isOpen]="ampliarGrafica" [export]="true" [iconoExport]="'image'" (exportFile)="exportarGrafica()" (close)="cerrarModales()">
  <div modal-header>
    <ng-container [ngTemplateOutlet]="tituloZonaTpl"></ng-container>
  </div>
  <div modal-body>
    <div class="contenidoModalGraf">
      @if (ampliarGrafica) {
        <app-graficador
          [data]="chartData"
          [labels]="chartLabels"
          [type]="type"
          [colors]="colorMulti"
          [axisX]="var2Sel"
          [axisY]="[ ('cues.analisis-clima.calificacion' | translate) ]"
          [legend]="legendGraf"
          [zona]="11"
          [etiquetas]="etiquetasZona1"
          [formatEtiquetas]="true"
        />
      }
    </div>
  </div>
</app-modal>
